const argsEdCliOS = (tipoAct, _id, estadoCliente, cargoMensual, saldoCl) => {
  // let fechaHoy = new Date()
  // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
  // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

  let actColecc = []
  let argsUpd = {
    "tipoAct": tipoAct,
    "_id": _id,
    "estadoCliente": estadoCliente,
    "cargoMensual": cargoMensual,
    "saldoPendiente": saldoCl,
  }
  actColecc.push(argsUpd)

  let colecc = {actColecc}

  return colecc
}

export default argsEdCliOS
